//styles
import {
  Container,
  IconContainer,
  ContentContainer,
  StatusIcon
} from './SmartAction.styles';

// types
import { SmartActionProps } from './SmartAction.types';
import { SmartActionState } from '../../SmartActionDialog.types';
import { Typography } from '@mui/material';

export const SmartAction = ({
  children,
  state = SmartActionState.NONE,
  title
}: SmartActionProps) => {
  if (state === SmartActionState.NONE) return <></>;

  return (
    <Container>
      <IconContainer>
        <StatusIcon
          type={
            state === SmartActionState.SUCCESS
              ? 'check'
              : 'triangle-exclamation'
          }
          state={state}
        />
      </IconContainer>

      <ContentContainer state={state}>
        <Typography variant="body1">{title}</Typography>
        {children}
      </ContentContainer>
    </Container>
  );
};
